module.exports = __webpack_public_path__ + "img/62131248000149.633f79af.png";